import { useLocales } from 'src/locales';

export const useCategories = () => {
  const { translate } = useLocales();

  const categories = [
    {
      title: translate('collaborate.docs.cover_categories.solid_colors'),
      valueName: 'colors',
    },
    {
      title: translate('collaborate.docs.cover_categories.gradients'),
      valueName: 'gradients',
    },
    {
      title: translate('collaborate.docs.cover_categories.architecture'),
      valueName: 'architectures',
    },
    {
      title: translate('collaborate.docs.cover_categories.land_scape'),
      valueName: 'landScape',
    },
    {
      title: translate('collaborate.docs.cover_categories.space'),
      valueName: 'space',
    },
  ];

  return categories;
};
